'use strict';
app.controller('savedworkspacecontroller', ['$scope', '$location', 'plotDataService', 'SaveGraphServices', 'GetSavedWorkSpaceServices', 'GetSpectrumIDServices', 'SpectrumIDService', 'GetAreaNameServices', 'progressBarService', '$rootScope', '$cookies', 'DeleteWokSpaceServices', '$window', '$timeout', 'CommonService', function ($scope, $location, plotDataService, SaveGraphServices, GetSavedWorkSpaceServices, GetSpectrumIDServices, SpectrumIDService, GetAreaNameServices, progressBarService, $rootScope, $cookies, DeleteWokSpaceServices, $window, $timeout, commonService) {

    if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined) {
        $location.path('/login');
        return;
    }

    if ($rootScope.isFirstLogin == '1' && $rootScope.hasSharedWorkspaces == '1') {
        $scope.activeTab = 2;
        $rootScope.isFirstLogin = '0';
        $('div.modal-backdrop').remove();
    } else {
        $scope.activeTab = 1;
    }

    $scope.serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
    $scope.eSpectraEmail = getLocalValue('emailId');
    $scope.currentU
    $scope.spectrumIdList = [];
    $scope.searchstringlist = [];
    $scope.workareaidlist = [];
    $scope.fileNameList = [];
    $scope.isShowPlus = true;
    $scope.captchaVisible = true;
    $scope.isShowSharedDatafields = false;
    //$scope.activeTab = 1;
    $scope.isDisableSaveBtn = true;
    //$scope.workspaceMsg = "Kindly search for a workspace.";
    $('#tblsavedworkSpace').hide();
    var workareaid = "";

    //if ($('#txtWorkspaceName').val() == "") {
    //    $scope.isDisableSaveBtn = true;
    //} else {
    //    $scope.isDisableSaveBtn = false;
    //}

    $rootScope.SearchLinkCSS = '';
    $rootScope.PlotGraphLinkCSS = 'disabled';
    $rootScope.SaveWorkspaceLinkCSS = 'active';

    $scope.totalNoOfRecordsofSavedWorkspace = 1 / 0;
    $scope.totalNoOfRecordsofSharedWorkspace = 1 / 0;
    $scope.currentPageOfSavedWorkspace = 1;
    if ($scope.currentPageOfSavedWorkspace == undefined) {
        $scope.currentPageOfSavedWorkspace = 1;
    }

    $scope.currentPageOfSharedWorkspace = 1;
    if ($scope.currentPageOfSharedWorkspace == undefined) {
        $scope.currentPageOfSharedWorkspace = 1;
    }

    $scope.pagingInfo = {
        savedPageNo: 1,
        sharedPageNo: 1,
        itemsPerPage: 10,
        savedWorkSortBy: 'eSpectraCreateTS',
        sharedWorkSortBy: 'eSpectraCreateTS',
        savedWorkReverse: true,
        sharedWorkReverse: true
    };


    $scope.setTab = function (tabNum) {
        $scope.activeTab = tabNum;
    }

    $scope.isSet = function (tabNum) {
        return $scope.activeTab == tabNum;
    }

    $scope.sort = function (sortBy, workspaceType) {
        if (workspaceType == 'savedworkSpace') {
            $scope.currentPageOfSavedWorkspace = 1;
            $scope.pagingInfo.savedPageNo = 1;
            if (sortBy === $scope.pagingInfo.savedWorkSortBy) {
                $scope.pagingInfo.savedWorkReverse = !$scope.pagingInfo.savedWorkReverse;
            } else {
                $scope.pagingInfo.savedWorkSortBy = sortBy;
                $scope.pagingInfo.savedWorkReverse = false;
            }
        } else {
            $scope.currentPageOfSharedWorkspace = 1;
            $scope.pagingInfo.sharedPageNo = 1;
            if (sortBy === $scope.pagingInfo.sharedWorkSortBy) {
                $scope.pagingInfo.sharedWorkReverse = !$scope.pagingInfo.sharedWorkReverse;
            } else {
                $scope.pagingInfo.sharedWorkSortBy = sortBy;
                $scope.pagingInfo.sharedWorkReverse = false;
            }
        }

        GetSavedWorkSpaceServices.GetSavedWorkSpace($scope);
    };

    $scope.addFields = function () {
        if ($scope.shareData.length < 10) {
            $scope.shareData.push({ name: "", emailID: "", isShowPlus: false, isValid: true });
        }
    }

    $scope.removeField = function (index) {
        $scope.shareData.splice(index, 1);
        $scope.checkSharedEmailID();
    }

    var SearStringResult = plotDataService.getSearchString();

    if (SearStringResult.length > 0) {
        for (var i = 0; i < SearStringResult.length; i++) {
            if ((SearStringResult[i].id != 0 || SearStringResult[i].FileName != '') && SearStringResult[i].IsValidFigureData) {
                $scope.spectrumIdList.push(SearStringResult[i].ObjectId);
                $scope.fileNameList.push(SearStringResult[i].FileName);
                $scope.searchstringlist.push(SearStringResult[i].Searchstring);
                //if (SearStringResult[i].FileName.trim() == '') {
                $scope.WorkAreaid = SearStringResult[i].WorkareaId;
                //} else {
                //    $scope.objectWorkSpaceId = SearStringResult[i].WorkareaId;
                //}
            }
        }
    }
    else {
        if ($location.$$path != '/savedWorkedSpace') {
            $location.path('/search');
            return false;
        }
    }

    $scope.chemicalname = plotDataService.getChemicalNameFromSetData().replace(/,\s*$/, "");;

    //if ($cookies.get('UserId') != null && $cookies.get('UserId') != 'undefined' && $cookies.get('UserId') != '') {
    //    $scope.UserId = $cookies.get('UserId');
    //}

    $scope.SessionUploadID = '';
    if ($cookies.get('SessionID') != null && $cookies.get('SessionID') != 'undefined' && $cookies.get('SessionID') != '') {
        $scope.SessionUploadID = $cookies.get('SessionID');
    }
    //$scope.isWorkspaceEditingByOwner = false;
    //if ($rootScope.SelectedWorkArea != null && $rootScope.SelectedWorkArea.name != '') {
    //    $("#lblTitle").addClass("active");
    //    $scope.isWorkspaceEditingByOwner = $scope.SelectedWorkArea.ownerId.toString() === $scope.UserId.toString();
    //}

    $scope.savedWorkspaceSearchResult = [];
    $scope.searchResultMsgforSavedWorkSpace = "";

    $scope.sharedWorkspaceSearchResult = [];
    $scope.searchResultMsgforSharedWorkSpace = "";

    if (angular.element("#txtWorkspaceName") == null) {
        GetSavedWorkSpaceServices.GetSavedWorkSpace($scope);
    }

    $("#saveGraphBtn").focus();

    $scope.displayShareWorkspaceModal = function (areaName, id, encId, index) {
        progressBarService.showProgressBar();
        $scope.shareData = [{
            name: "", emailID: "", isShowPlus: true, isValid: true
        }];
        $scope.message = "";
        $scope.isError = false;
        $scope.isSameEmailID = true;
        $scope.ShareUserForm.$setPristine();
        $scope.ShareUserForm.$setUntouched();
        $scope.sharedWorkSpaceUsers = [];
        $scope.isShowSharedDatafields = false;
        $scope.savedWorkSpaceId = id;
        $scope.savedWorkSpaceEncId = encId;
        $scope.currentSavedWorkspaceIndex = index;
        var workspaceurl = $scope.workspaceurl + encId;
        $('#lblWorkSpaceUrl').html(workspaceurl);
        $scope.workAreaName = areaName;
        GetSavedWorkSpaceServices.GetSharedUsers($scope);
    }

    $scope.deleteSharedUser = function (sharedUserID, workareaId, workShareID, workspaceType, index) {
        $scope.WorkAreaId = workareaId;
        $scope.SharedUserId = sharedUserID;
        var element = document.getElementById("share-arrow-0");
        $scope.sharedWorkSpaceUsers.splice(index, 1);
        if (index == 0 && $scope.sharedWorkSpaceUsers.length > 1 && element.classList.contains("fa-caret-down")) {
            $scope.sharedWorkSpaceUsers[index].isShowArrow = true;
            $scope.sharedWorkSpaceUsers[index].isShowDownArrow = true;
            $scope.sharedWorkSpaceUsers[index].isShowRightArrow = false;
        } else if ($scope.sharedWorkSpaceUsers.length > 1 && element.classList.contains("fa-caret-right")) {
            element = document.getElementById("share-arrow-" + (index + 1))
            element.classList.remove("ng-hide");
            $scope.sharedWorkSpaceUsers[0].isShowArrow = true;
            $scope.sharedWorkSpaceUsers[0].isShow = true;
            $scope.sharedWorkSpaceUsers[index].isShowDownArrow = false;
            $scope.sharedWorkSpaceUsers[index].isShowRightArrow = true;
        } else if ($scope.sharedWorkSpaceUsers.length == 1) {
            $scope.sharedWorkSpaceUsers[0].isShow = true;
        }
        if (workspaceType == 'savedWorkspace') {
            $scope.savedWorkspaceSearchResult[$scope.currentSavedWorkspaceIndex].workspaceCount = $scope.sharedWorkSpaceUsers.length;
        }
        DeleteWokSpaceServices.DeleteSavedWorkSpace($scope, "WorkspaceSharedUser", workShareID);
    }

    //This Method Will Call Save Button.
    $scope.SaveWorkSpace = function ($event) {
        $rootScope.selectedWorkspaceName = 'Choose Workspace';
        var keyCode = $event.which || $event.keyCode;

        if (keyCode === 13 || keyCode == 1) {
            if (angular.element("#txtWorkspaceName").val().trim() != '') {
                $("#txtWorkspaceName").removeClass("border-red");
                $("#txtWorkspaceName").siblings("label").find("span").hide();

                var workspaceid = 0;
                //var objectWorkspaceId = 0;
                if ($rootScope.SelectedWorkArea != null && $rootScope.SelectedWorkArea.name != '') {
                    workspaceid = $rootScope.SelectedWorkArea.id;
                    //objectWorkspaceId = $rootScope.SelectedWorkArea.objectWorkSpaceId;
                }
                var isCreateNewWorkspace = $rootScope.SelectedWorkArea == null ? true : false;

                var deletedSearchStringList = plotDataService.getDeletedSearchString();
                $scope.deletedSearchString = [];
                for (var i = 0; i < deletedSearchStringList.length; i++) {
                    $scope.deletedSearchString.push(deletedSearchStringList[i].Searchstring);
                }

                $scope.deletedObjectIDs = plotDataService.getDeletedObjectIDList().length > 0 ? plotDataService.getDeletedObjectIDList() : [];

                SaveGraphServices.SaveWorkSpace($scope, workspaceid, isCreateNewWorkspace);
            }
            else {
                $("#txtWorkspaceName").addClass("border-red");
                $("#txtWorkspaceName").focus();
                $("#spanTitleError").html("Invalid workspace name.");
                $("#txtWorkspaceName").siblings("label").find("span").fadeIn();
            }
        }
    }

    $scope.SaveAsWorkSpace = function () {
        $rootScope.selectedWorkspaceName = 'Choose Workspace';
        if (angular.element("#txtWorkspaceName").val().trim() != '') {
            $("#txtWorkspaceName").removeClass("border-red");
            $("#txtWorkspaceName").siblings("label").find("span").hide();
            var deletedSearchStringList = plotDataService.getDeletedSearchString();
            $scope.deletedSearchString = [];
            for (var i = 0; i < deletedSearchStringList.length; i++) {
                $scope.deletedSearchString.push(deletedSearchStringList[i].Searchstring);
            }
            $scope.deletedObjectIDs = plotDataService.getDeletedObjectIDList().length > 0 ? plotDataService.getDeletedObjectIDList() : [];
            SaveGraphServices.SaveWorkSpace($scope, 0, 'true');
        }
        else {
            $("#txtWorkspaceName").addClass("border-red");
            $("#txtWorkspaceName").focus();
            $("#spanTitleError").html("Invalid workspace name.");
            $("#txtWorkspaceName").siblings("label").find("span").fadeIn();
        }
    }

    $scope.CloseWorkSpace = function () {
        $rootScope.SelectedWorkArea = null;
        //GetSpectrumIDServices.deleteUnpublishedDataSets($scope, '', '', true);
        plotDataService.clearSpectrumIds();
        plotDataService.clearTechnique();
        plotDataService.clearFiles();
        plotDataService.clearDataSetDisplayString();
        plotDataService.clearSearchString();
    }

    function SavedWorkspaces_Load() {
        if ($location.$$path == '/savedWorkedSpace') {
            $scope.CloseWorkSpace();
            $scope.pagingInfo.savedPageNo = 1;
            $scope.pagingInfo.sharedPageNo = 1;
            $scope.currentPageOfSavedWorkspace = 1;
            $scope.currentPageOfSharedWorkspace = 1;
            $("#SearchWorkspace").focus();
            GetSavedWorkSpaceServices.GetSavedWorkSpace($scope);
        }
    }

    $scope.LoadWorkspaces = function () {
        $('#shareWorkSpaceModal').modal('hide');
        $scope.isShowSharedDatafields = "";
        $scope.nameShare = "";
        $scope.emailIdToShare = "";
        $scope.isShowSharedDatafields = "";
        //$rootScope.$broadcast('reloadCaptcha', {});
        $scope.ShareUserForm.$setPristine();
        $scope.ShareUserForm.$setUntouched();
        $scope.isShowPlus = true;
        $scope.isError = false;
        $scope.message = "";
        SavedWorkspaces_Load();
    };

    $scope.SearchWorkSpace = function (fromObject, $event) {
        var keyCode = $event.which || $event.keyCode;

        if (keyCode === 13 || keyCode == 1) {
            if (fromObject == 'fromSearchButton') {
                $scope.pagingInfo.savedPageNo = 1;
                $scope.pagingInfo.sharedPageNo = 1;
                $scope.currentPageOfSavedWorkspace = 1;
                $scope.currentPageOfSharedWorkspace = 1;
            }
            else {
                $scope.pagingInfo.savedPageNo = $scope.currentPageOfSavedWorkspace;
                $scope.pagingInfo.sharedPageNo = $scope.currentPageOfSharedWorkspace;
            }
            if (angular.element("#txtAreatitle").val() == "") {
                $("#exampleInputAmount").removeClass("active");
                $("#SearchWorkspace").focus();
            }

            GetSavedWorkSpaceServices.GetSavedWorkSpace($scope);
        }
    }

    $scope.setSavedPage = function (pageNo, $event) {
        $scope.currentPageOfSavedWorkspace = pageNo;
        $scope.pagingInfo.savedPageNo = pageNo;
        GetSavedWorkSpaceServices.GetSavedWorkSpace($scope);
        //$scope.workspaceMsg = "Kindly search for a workspace.";
        $('#tblsavedworkSpace').hide();
    };

    $scope.setSharedPage = function (pageNo, $event) {
        $scope.currentPageOfSharedWorkspace = pageNo;
        $scope.pagingInfo.sharedPageNo = pageNo;
        GetSavedWorkSpaceServices.GetSavedWorkSpace($scope);
        $('#tblsharedworkSpace').hide();
    };

    $scope.reset = function (event) {
        $('label').removeClass('active');
        angular.element("#txtAreatitle").val('');
        $scope.pagingInfo = {
            savedPageNo: 1,
            sharedPageNo: 1,
            itemsPerPage: 10,
            savedWorkSortBy: 'eSpectraCreateTS',
            sharedWorkSortBy: 'eSpectraCreateTS',
            savedWorkReverse: true,
            sharedWorkReverse: true
        };
        SavedWorkspaces_Load();
    }

    SavedWorkspaces_Load();

    //This method will redirect to plot Graph.
    $scope.RedirecttoPloatgraph = function (event, mode, workspaceType) {
        progressBarService.showProgressBar();
        plotDataService.clearSpectrumIds();
        plotDataService.clearTechnique();
        plotDataService.clearFiles();
        plotDataService.clearDataSetDisplayString();
        plotDataService.clearSearchString();
        $rootScope.SelectedWorkArea = null;

        if (event.target.id != null && event.target.id > 0) {
            var workAreaID = event.target.id;
            $scope.WorkAreaid = workAreaID;
            $rootScope.selectedWorkspaceName = event.target.name;
        }
        else {
            $scope.WorkAreaid = $scope.savedWorkSpaceId;
            //$scope.ObjectWorkSpaceId = $scope.savedObjectWorkSpaceId;
        }

        $rootScope.workspaceID = $scope.WorkAreaid;

        GetSpectrumIDServices.GetWorkSpaceByID($scope, mode, workspaceType);
        $('#shareWorkSpaceModal').modal('hide');
        $scope.isShowSharedDatafields = false;
    }

    $scope.setTextboxStyle = function () {
        $(".input-feild-textbox").on("focusin", function () {
            $(this).parent().siblings("label").addClass("active");
            $(this).siblings("label").addClass("active");
        }).focusout(function () {
            if (!$(this).val().trim()) {
                $(this).parent().siblings("label").removeClass("active");
                $(this).siblings("label").removeClass("active");
            }
        });
    };

    $scope.setTextboxStyle();

    //This is method will delete saved Work Space.
    $scope.DeleteWorkSpace = function (workAreaId, workspaceType, workShareID) {

        if ($window.confirm("Are you sure you want to delete this record?")) {
            $scope.WorkAreaId = workAreaId;
            DeleteWokSpaceServices.DeleteSavedWorkSpace($scope, workspaceType, workShareID);
            $scope.result = "Yes";
        }
        else {
            $scope.result = "No";
        }
    }

    $scope.ShowDataSetSearchDetails = function (workAreaID, workAreaDetail, typeOfWorkspace) {
        var spectrunID = workAreaDetail.spectrumID;
        var searchResults = typeOfWorkspace == 'MyWorkspace' ? $scope.savedWorkspaceSearchResult : $scope.sharedWorkspaceSearchResult;
        $scope.dataSetSearchDetails = null;
        for (var i = 0; i < searchResults.length; i++) {
            if (searchResults[i].workAreaID == workAreaID) {
                for (var count = 0; count < searchResults[i].workAreaDetails.length; count++) {
                    var isShow = searchResults[i].workAreaDetails[count].technique.toLowerCase() == 'uv-vis' ? searchResults[i].workAreaDetails[count].objectDataSetName == workAreaDetail.objectDataSetName : searchResults[i].workAreaDetails[count].spectrumID == spectrunID;
                    if (isShow) {
                        var temp = searchResults[i].workAreaDetails[count].searchStringList.split("|");
                        if (temp != "") {
                            if (temp.indexOf('Technique:UV-VIS') > 0 || temp.indexOf('Technique:UV-Vis') > 0) {
                                $scope.dataSetSearchDetails = {
                                    spectrumID: spectrunID,
                                    keyWord: temp[0].split(":")[1],
                                    chemicalName: temp[1].split(":")[1],
                                    casRegistryNumber: temp[2].split(":")[1],
                                    technique: temp[3].split(":")[1],
                                    authorLastName: temp[4].split(":")[1],
                                    publicationYear: temp[5].split(":")[1],
                                    sourceTitle: temp[6].split(":")[1],
                                };
                            }
                            else {
                                $scope.dataSetSearchDetails = {
                                    spectrumID: spectrunID,
                                    keyWord: temp[0].split(":")[1],
                                    chemicalName: temp[1].split(":")[1],
                                    element: temp[2].split(":")[1],
                                    hostMaterial: temp[3].split(":")[1],
                                    transition: temp[4].split(":")[1],
                                    technique: temp[5].split(":")[1],
                                    accession: temp[6].split(":")[1],
                                    authorLastName: temp[7].split(":")[1],
                                    spectralRegion: temp[8].split(":")[1],
                                    startValue: temp[9].split(":")[1],
                                    endValue: temp[10].split(":")[1],
                                    fromYear: temp[11].split(":")[1],
                                    todate: temp[12].split(":")[1],
                                    doi: temp[13].split(":")[1]
                                };
                            }
                        }
                        break;
                    }
                }
            }
        }

        $('#searchTermsModal').modal('show');
    }

    $scope.ShowDataSetSearchDetailsForSave = function (dataSet) {
        var spectrunID = dataSet.SpectrumId;
        $scope.dataSetSearchDetailsToSave = null;
        var searchString = plotDataService.getSearchString();

        if (searchString != null) {
            for (var i = 0; i < searchString.length; i++) {
                var isShow = dataSet.Technique.toLowerCase() == 'uv-vis' ? searchString[i].FileName == dataSet.FileName : searchString[i].id == spectrunID;
                if (isShow) {

                    var temp = searchString[i].Searchstring.split("|");
                    if (temp != "") {
                        if (temp.indexOf('Technique:UV-VIS') > 0 || temp.indexOf('Technique:UV-Vis') > 0) {
                            $scope.dataSetSearchDetailsToSave = {
                                spectrumID: spectrunID,
                                keyWord: temp[0].split(":")[1],
                                chemicalName: temp[1].split(":")[1],
                                casRegistryNumber: temp[2].split(":")[1],
                                technique: temp[3].split(":")[1],
                                authorLastName: temp[4].split(":")[1],
                                publicationYear: temp[5].split(":")[1],
                                sourceTitle: temp[6].split(":")[1],
                            };
                        } else {
                            $scope.dataSetSearchDetailsToSave = {
                                spectrumID: spectrunID,
                                keyWord: temp[0].split(":")[1],
                                chemicalName: temp[1].split(":")[1],
                                element: temp[2].split(":")[1],
                                hostMaterial: temp[3].split(":")[1],
                                transition: temp[4].split(":")[1],
                                technique: temp[5].split(":")[1].replace("UNSPECIFIED", "Unspecified"),
                                accession: temp[6].split(":")[1],
                                authorLastName: temp[7].split(":")[1],
                                spectralRegion: temp[8].split(":")[1].replace("UNSPECIFIED", "Unspecified"),
                                startValue: temp[9].split(":")[1],
                                endValue: temp[10].split(":")[1],
                                fromYear: temp[11].split(":")[1],
                                todate: temp[12].split(":")[1],
                                doi: temp[13].split(":")[1]
                            };
                        }
                    }
                    break;
                }
            }

        }

        $('#searchTermsModal').modal('show');
    }

    $scope.$on('ngRepeatBroadcast1', function (ngRepeatFinishedEvent) {
        progressBarService.hideProgressBar();
    });

    $scope.DisplayDataSetToSave = function () {

        //$scope.dataSetsToSave = plotDataService.getSetdata();
        $scope.dataSetsToSave = [];
        var data = plotDataService.getSetdata();

        angular.forEach(data, function (value, key) {
            if (value.isValidFigureData) {
                value.SpectrumId = value.SpectrumId == value.ObjectID ? 0 : value.SpectrumId;
                $scope.dataSetsToSave.push(value);
            }
        });

        $.each($scope.dataSetsToSave, function (index, value) {
            if (value.IsCurated == true) {
                $scope.isAnyCurated = true;
                return false;
            }
        });
    }

    $scope.DisplayDataSetToSave();

    $scope.ShareGraph = function () {
        angular.element("#divEmailSend").show();
    }

    $scope.SendEmailCancel = function () {
        angular.element("#emailIdToShare").val('');
        $("#emailIdToShare").removeClass("active");
        $("#emailIdToShare").siblings("label").removeClass("active");
        $("#emailIdToShare").removeClass("border-red");
        $("#emailIdToShare").siblings("label").find("span").fadeOut();
        angular.element("#nameShare").val('');
        $("#nameShare").removeClass("border-red");
        $("#nameShare").siblings("label").find("span").fadeOut();
        $("#nameShare").removeClass("active");
        $("#nameShare").siblings("label").removeClass("active");
        angular.element("#divEmailSend").hide();
        $('#shareWorkSpaceModal').modal('hide');
        $scope.isShowSharedDatafields = false;
    }

    $scope.SendEmail = function (workspaceType) {
        progressBarService.showProgressBar();
        //$scope.sharedWorkSpaceUsers = $scope.sharedWorkSpaceUsers == undefined ? []: $scope.sharedWorkSpaceUsers;
        var isNotExist = true, i, sharememberList = [], duplicateEmailIds = '';
        if ($scope.sharedWorkSpaceUsers.length > 1 && $scope.sharedWorkSpaceUsers[0].isShowDownArrow) {
            $scope.sharedWorkSpaceUsers[0].isShowDownArrow = !$scope.sharedWorkSpaceUsers[0].isShowDownArrow;
            $scope.sharedWorkSpaceUsers[0].isShowRightArrow = !$scope.sharedWorkSpaceUsers[0].isShowRightArrow;
            angular.forEach($scope.sharedWorkSpaceUsers, function (value, key) {
                if (key > 0) {
                    $scope.sharedWorkSpaceUsers[key].isShow = !$scope.sharedWorkSpaceUsers[key].isShow;
                }
            });
        }

        //if ($scope.isAnyCurated) {
        //    var email = angular.element("#emailIdToShare").val();
        //    commonService.getUserByEmail(email).then(function (response) {
        //        if (response != null && response.data.message == undefined && response.data.isPremiumType != 2) {
        //            $("#emailIdToShare").addClass("border-red");
        //            $("#emailIdToShare").focus();
        //            $("#emailIdToShare").siblings("label").find("span").fadeIn();
        //            $('#spanEmailError').text('Curated data can share with premium users only.');
        //            progressBarService.hideProgressBar();
        //        } else {
        //            // Send Mail
        //            SaveGraphServices.ShareWorkSpace($scope, angular.element("#nameShare").val(), angular.element("#emailIdToShare").val(), $("#lblWorkSpaceUrl").html(), $scope.savedWorkSpaceId);
        //        }
        //    });
        //} else {
        // Send Mail
        for (i = 0; i < $scope.shareData.length; ++i) {
            if ($scope.shareData[i].emailID.length > 0) {
                sharememberList.push({
                    inviteeName: $scope.shareData[i].name,
                    To: $scope.shareData[i].emailID,
                    Url: $scope.savedWorkSpaceEncId,
                    WorkAreaId: $scope.savedWorkSpaceId,
                    SharingPersonName: getLocalValue('fullName'),
                    WorkSpaceName: angular.element("#txtWorkspaceName").val()
                });
            }
        }
        angular.forEach($scope.sharedWorkSpaceUsers, function (datavalue, datakey) {
            angular.forEach(sharememberList, function (value, key) {
                if (datavalue.eSpectraSharedUserEmailID.toLowerCase() == value.To.toLowerCase()) {
                    duplicateEmailIds = duplicateEmailIds + "\"" + value.To + "\" ";
                    sharememberList.splice(key, 1);

                }
            });
        });

        if (sharememberList.length > 0) {
            SaveGraphServices.ShareWorkSpace($scope, sharememberList, $("#lblWorkSpaceUrl").html(), workspaceType);
        } else {

            progressBarService.hideProgressBar();
        }
        if (duplicateEmailIds != "") {
            $scope.message = "Workspace is already shared to " + duplicateEmailIds + ". "
            $scope.isError = true;
        }
        $scope.shareData = [{
            name: "", emailID: "", isShowPlus: true
        }];
        $scope.ShareUserForm.$setPristine();
        $scope.ShareUserForm.$setUntouched();
    }


    $scope.removeTagOnBackspace = function (event) {
        if (event.keyCode === 8) {
            $("#spanEmailError").hide();
            $("#emailIdToShare").removeClass("border-red");
        }
    };

    $scope.ValidateToSendEmail = function () {
        var returnVal = true;
        if (angular.element("#nameShare").val() != '') {
            $("#nameShare").removeClass("border-red");
            $("#nameShare").siblings("label").find("span").fadeOut();
        }
        else {
            $("#nameShare").addClass("border-red");
            $("#nameShare").focus();
            $("#nameShare").siblings("label").find("span").fadeIn();
            returnVal = false;
        }
        if (angular.element("#emailIdToShare").val() != '') {
            var email = angular.element("#emailIdToShare").val();
            var regExp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,3}|[0-9]{1,3})(\]?)$/;

            var isValid = regExp.test(email);
            if (isValid) {
                $("#emailIdToShare").removeClass("border-red");
                $("#emailIdToShare").siblings("label").find("span").fadeOut();
            }
            else {
                $("#emailIdToShare").addClass("border-red");
                if (returnVal) {
                    $("#emailIdToShare").focus();
                }
                $("#emailIdToShare").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
        }
        else {
            $("#emailIdToShare").addClass("border-red");
            if (returnVal) {
                $("#emailIdToShare").focus();
            }
            $("#emailIdToShare").siblings("label").find("span").fadeIn();
            returnVal = false;
        }

        if (!$scope.captchaValid) {
            returnVal = false;
        }

        return returnVal;
    }

    $scope.ShowAllSharedUsers = function () {
        $scope.sharedWorkSpaceUsers[0].isShowDownArrow = !$scope.sharedWorkSpaceUsers[0].isShowDownArrow;
        $scope.sharedWorkSpaceUsers[0].isShowRightArrow = !$scope.sharedWorkSpaceUsers[0].isShowRightArrow;
        angular.forEach($scope.sharedWorkSpaceUsers, function (value, key) {
            if (key > 0) {
                $scope.sharedWorkSpaceUsers[key].isShow = !$scope.sharedWorkSpaceUsers[key].isShow;
            }
        });
    }

    if (($rootScope.SelectedWorkArea != null && $rootScope.SelectedWorkArea.name != '' && (plotDataService.getSpectrumIds().length > 0 || plotDataService.getFiles().length > 0))) {
        $rootScope.PlotGraphLinkCSS = '';
        angular.element(document.getElementsByClassName("plotting-area")).parent().removeClass("disabled");
        angular.element(document.getElementsByClassName("plotting-area")).removeClass("disabled").attr("disabled", false);
        $scope.workSpaceName = $rootScope.SelectedWorkArea.name;
        if ($scope.workSpaceName) {
            $('#lblTitle').addClass('active');
            $("#txtWorkspaceName").focus();
            $scope.isDisableSaveBtn = false;
        }
        $scope.originalWorkSpaceName = $rootScope.SelectedWorkArea.name;
        $scope.workspaceOwnerId = $rootScope.SelectedWorkArea.ownerId;
    }
    else {
        $rootScope.PlotGraphLinkCSS = 'disabled';
        angular.element(document.getElementsByClassName("plotting-area")).parent().addClass("disabled");
        angular.element(document.getElementsByClassName("plotting-area")).addClass("disabled").attr("disabled", true);
    }

    $scope.checkWorkspaceName = function () {
        if ($scope.workSpaceName == "") {
            $scope.isDisableSaveBtn = true;
        } else if ($scope.workSpaceName == " ") {
            $scope.workSpaceName = "";
            $scope.isDisableSaveBtn = true;
        } else if ($scope.originalWorkSpaceName != undefined) {
            if ($scope.workSpaceName == $scope.originalWorkSpaceName) {
                $scope.isDisableSaveBtn = false;
            } else {
                $scope.isDisableSaveBtn = true;
            }
        } else {
            $scope.isDisableSaveBtn = false;
        }
    }

    $scope.checkSharedEmailID = function () {
        var element;
        $scope.isValid = true;
        angular.forEach($scope.shareData, function (value, key) {
            angular.forEach($scope.shareData, function (value1, key1) {

                if (value.emailID.toLowerCase() == $scope.eSpectraEmail.toLowerCase()) {
                    isSameEmailID = true;
                    $scope.isValid = false;
                    element = document.getElementById("emailIdToShare_" + key);
                    $(element).addClass('border-red');
                }
                else if (key != key1) {
                    if (value.emailID.toLowerCase() == value1.emailID.toLowerCase()) {
                        isSameEmailID = true;
                        $scope.isValid = false;
                    }
                }
            });
        });
    }
}]);

app.service('DeleteWokSpaceServices', ['$http', '$window', '$cookies', function ($http, $window, $cookies) {

    this.DeleteSavedWorkSpace = function ($scope, workspaceType, workShareID) {
        //var userID = "";
        //userID = $cookies.get('UserId');
        return $http({
            method: "GET",
            url: $scope.serviceBase + "DeleteSavedWorkSpace",
            params: { WorkAreaID: $scope.WorkAreaId, WorkspaceType: workspaceType, eSpectraShareID: workShareID },
            headers: { 'Content-Type': 'application/json' }
        }).success(function (data, status) {
            if (status == "204") {
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
            }
            else {
                if (data == "1") {
                    //$window.location.reload();
                    var index;
                    if (workspaceType == 'savedWorkspace') {
                        for (var i = 0; i < $scope.savedWorkspaceSearchResult.length; i++) {
                            if ($scope.savedWorkspaceSearchResult[i].workAreaID == $scope.WorkAreaId) {
                                index = i;
                                break;
                            }
                        }

                        $scope.savedWorkspaceSearchResult.splice(index, 1);
                        if ($scope.savedWorkspaceSearchResult.length <= 0) {
                            $scope.currentPageOfSavedWorkspace = 1;
                            $scope.pagingInfo.savedPageNo = 1;
                        }
                        var sort = $scope.pagingInfo.savedWorkSortBy;
                        $scope.pagingInfo.savedWorkReverse = !$scope.pagingInfo.savedWorkReverse;
                        $scope.sort(sort, 'savedworkSpace');
                    } else if (workspaceType == "sharedWorkspace") {
                        for (var i = 0; i < $scope.sharedWorkspaceSearchResult.length; i++) {
                            if ($scope.sharedWorkspaceSearchResult[i].workAreaID == $scope.WorkAreaId) {
                                index = i;
                                break;
                            }
                        }

                        $scope.sharedWorkspaceSearchResult.splice(index, 1);
                        if ($scope.sharedWorkspaceSearchResult.length <= 0) {
                            $scope.currentPageOfSavedWorkspace = 1;
                            $scope.pagingInfo.sharedPageNo = 1;
                        }
                        var sort = $scope.pagingInfo.sharedWorkSortBy;
                        $scope.pagingInfo.sharedWorkReverse = !$scope.pagingInfo.sharedWorkReverse;
                        $scope.sort(sort, 'sharedworkSpace');
                    }
                    //else {
                    //    for (var i = 0; i < $scope.sharedWorkSpaceUsers.length; i++) {
                    //        if ($scope.sharedWorkSpaceUsers[i].workspaceSharedUserID == $scope.SharedUserId) {
                    //            index = i;
                    //            break;
                    //        }
                    //    }
                    //    $scope.sharedWorkSpaceUsers.splice(index, 1);
                    //    $scope.savedWorkspaceSearchResult[$scope.currentSavedWorkspaceIndex].workspaceCount = $scope.sharedWorkSpaceUsers.length;
                    //}
                }
            }
        }).error(function (data, status) {
            if (status == "204") {
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
            }
        });
    };
}]);

app.service('GetAreaNameServices', ['$http', function ($http) {

}]);

// This Service Call GetSpectrumID Method.This will Fetech SpectrumID from dadatabse based on WorkAreaID.
app.service('GetSpectrumIDServices', ['$http', '$location', 'SpectrumIDService', 'plotDataService', 'progressBarService', '$rootScope', '$cookies', '$route', function ($http, $location, SpectrumIDService, plotDataService, progressBarService, $rootScope, $cookies, $route) {

    this.GetWorkSpaceByID = function ($scope, mode, workspaceType) {
        var spectrumIds = [];
        var SearchString = [];
        var WorkAreaID = [];
        var premiumType = getLocalValue('premiumType');
        return $http({
            method: "GET",
            url: $scope.serviceBase + "GetWorkSpaceByID",
            params: { DataSetIds: $scope.WorkAreaid },
            headers: { 'Content-Type': 'application/json' }
        }).success(function (data, status) {
            if (status == "204") {
                $scope.searchResultMsgforSavedWorkSpace = "No data found.";
                $scope.searchResultMsgforSharedWorkSpace = "No data found.";
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
                progressBarService.hideProgressBar();
            }
            else {
                var workAreaId, workAreaName, workspaceOwnerId;
                var isUVTechData = data.length > 0 && data[0].technique.toLowerCase() == 'uv-vis' ? true : false;
                for (var key in data) {
                    if (data[key].workAreaID != undefined) {
                        if (data[key].objectDataSetName != "" && data[key].objectContentType.toLowerCase() != 'kratos') { // for kratos data with objectDataSetName
                            plotDataService.addFileList(data[key].objectID);
                        }

                        workAreaId = data[key].workAreaID;
                        workAreaName = data[key].areaName;
                        workspaceOwnerId = data[key].eSpectraPersonID;

                        data[key].spectrumID = data[key].spectrumID == 0 && data[key].objectContentType.toLowerCase() == 'kratos' ? data[key].objectID : data[key].spectrumID; // for kratos data with zero spectrum ID

                        plotDataService.addSetdata(data[key].workAreaID, data[key].spectrumID > 0 ? data[key].objectID : 0, data[key].spectrumID, data[key].technique, data[key].chemicalName, data[key].hostMaterial, data[key].spectralRegion, data[key].pubDate, data[key].dOI, data[key].objectDataSetName != "" && data[key].objectContentType.toLowerCase() != 'kratos' ? data[key].objectID : "", data[key].isCurated, data[key].isValidFigureData); // for kratos data with zero spectrum ID
                        if (data[key].spectrumID > 0) {
                            plotDataService.addSpectrumId(data[key].objectID);
                        }
                        plotDataService.addChemicalname(data[key].chemicalName);
                        plotDataService.addSearchString(data[key].searchStringList, data[key].spectrumID > 0 ? data[key].objectID : 0, data[key].spectrumID, workAreaId, data[key].objectDataSetName != "" && data[key].objectContentType.toLowerCase() != 'kratos' ? data[key].objectID : "", data[key].isValidFigureData); // for kratos data with zero spectrum ID
                        plotDataService.setTechnique(data[key].objectID, data[key].technique, true);
                    }
                }

                $rootScope.SelectedWorkArea = { id: workAreaId, name: workAreaName, ownerId: workspaceOwnerId, workspaceType: workspaceType, isUVTechData: isUVTechData };

                if (mode == "edit") {
                    $location.path('/search/edit');
                    if ($route.current.originalPath == "/search/:mode") {
                        $route.reload();
                    }
                }
                else {
                    $location.path('/plotgraph');
                }
            }
        }).error(function (data, status) {
            if (status == "204") {
                $scope.searchResultMsgforSavedWorkSpace = "No data found.";
                $scope.searchResultMsgforSharedWorkSpace = "No data found.";
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
            }
            progressBarService.hideProgressBar();
        });
    };

    this.deleteUnpublishedDataSets = function ($scope, uniqueID, filename, deleteAllRows) {
        return $http({
            method: "GET",
            url: $scope.serviceBase + "deleteFiles",
            params: { 'uniqueID': uniqueID, 'sessionID': $scope.SessionUploadID, 'deleteAllRows': deleteAllRows },
            headers: { 'Content-Type': 'application/json' }
        }).success(function (data, status) {
            if (status != "204") {
                if (!deleteAllRows) {
                    plotDataService.removeUnPublishedDataSet(filename);
                    --$scope.unPublishedIDs;
                    if ($scope.UnPublishedDataSetCount <= 0) {
                        $(".clear-all-datasets").show();
                    }
                    $scope.$apply();
                }
                else {
                    plotDataService.clearUnPublishedDataSet();
                    $scope.unPublishedIDs = 0;
                    $scope.$apply();
                }
            }
        }).error(function (data, status) {
            if (status == "204") {
            }
        });
    };

}]);

//This Service Will add /retrive SpectrumID so that on while ploting We can use these IDs.
app.service('SpectrumIDService', function () {

});

//This method will Fetech Saved Work Spaces to display.
app.service('GetSavedWorkSpaceServices', ['progressBarService', '$http', '$cookies', function (progressBarService, $http, $cookies) {
    this.GetSavedWorkSpace = function ($scope) {
        progressBarService.showProgressBar();
        $scope.savedWorkspaceSearchResult = [];
        $scope.sharedWorkspaceSearchResult = [];
        $scope.searchResultMsgforSavedWorkSpace = "";
        $scope.searchResultMsgforSharedWorkSpace = "";
        return $http({
            method: "GET",
            url: $scope.serviceBase + "GetSavedWorkedSpace",
            params: { AreaName: $("#txtAreatitle").val(), SavedPageNo: $scope.pagingInfo.savedPageNo, itemsPerPage: $scope.pagingInfo.itemsPerPage, SavedWorkOrderBy: $scope.pagingInfo.savedWorkSortBy, SavedWorkSortDirection: $scope.pagingInfo.savedWorkReverse, SharedPageNo: $scope.pagingInfo.sharedPageNo, SharedWorkOrderBy: $scope.pagingInfo.sharedWorkSortBy, SharedWorkSortDirection: $scope.pagingInfo.sharedWorkReverse },
            headers: { 'Content-Type': 'application/json' }
        }).success(function (data, status) {
            if (status == "204") {
                $(".no-dataset-msg").show();
                $(".toggle-all-row-element").fadeOut();
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                $(".no-dataset-msg").addClass("animate");
                $scope.searchResultMsgforSavedWorkSpace = "No data found.";
                $scope.searchResultMsgforSharedWorkSpace = "No data found.";
                $('#tblsavedworkSpace').hide();
                $('#tblsharedworkSpace').hide();
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
                progressBarService.hideProgressBar();
            }
            else {
                if ($scope.pagingInfo.savedPageNo == 1) {
                    $scope.totalNoOfRecordsofSavedWorkspace = data.totalNoOfRecordsofSavedWorkspace;
                }

                if ($scope.pagingInfo.sharedPageNo == 1) {
                    $scope.totalNoOfRecordsofSharedWorkspace = data.totalNoOfRecordsofSharedWorkspace;
                }

                if (data.savedWorkspaceSearchResult.length > 0) {
                    $scope.workspaceurl = "http://" + location.host + location.pathname + "#/plotgraph?workspacedid=";
                    $scope.savedWorkspaceSearchResult = data.savedWorkspaceSearchResult;
                    $scope.workspaceMsg = '';
                    $('#tblsavedworkSpace').show();
                }
                else {
                    $scope.searchResultMsgforSavedWorkSpace = "No data found.";
                    $('#tblsavedworkSpace').hide();
                }

                if (data.sharedWorkspaceSearchResult.length > 0) {
                    $scope.workspaceurl = "http://" + location.host + location.pathname + "#/plotgraph?workspacedid=";
                    $scope.sharedWorkspaceSearchResult = data.sharedWorkspaceSearchResult;
                    $scope.workspaceMsg = '';
                    $('#tblsharedworkSpace').show();
                }
                else {
                    $scope.searchResultMsgforSharedWorkSpace = "No data found.";
                    $('#tblsharedworkSpace').hide();
                }
                progressBarService.hideProgressBar();
            }
        }).error(function (data, status) {
            if (status == "204") {
                $(".no-dataset-msg").show();
                $(".toggle-all-row-element").fadeOut();
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                $(".no-dataset-msg").addClass("animate");
                $scope.searchResultMsgforSavedWorkSpace = "No data found.";
                $scope.searchResultMsgforSharedWorkSpace = "No data found.";
                $('#tblsavedworkSpace').hide();
                $('#tblsharedworkSpace').hide();
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
            }
            progressBarService.hideProgressBar();
        });
    };

    this.GetSharedUsers = function ($scope) {
        return $http({
            method: "GET",
            url: $scope.serviceBase + "GetSharedUsers",
            params: { workAreaID: $scope.savedWorkSpaceId },
            headers: { 'Content-Type': 'application/json' }
        }).success(function (data, status) {
            if (status == "204") {
                $('.copied-url-msg').addClass('hide');
                $('#shareWorkSpaceModal').modal('show');
                progressBarService.hideProgressBar();
            } else {
                progressBarService.hideProgressBar();
                $scope.sharedWorkSpaceUsers = data;
                $scope.sharedWorkSpaceUsers[0].isShow = true;
                $scope.sharedWorkSpaceUsers[0].isShowArrow = true;
                $scope.sharedWorkSpaceUsers[0].isShowRightArrow = true;
                $scope.sharedWorkSpaceUsers[0].isShowDownArrow = false;
                angular.forEach($scope.sharedWorkSpaceUsers, function (value, key) {
                    if (key > 0) {
                        $scope.sharedWorkSpaceUsers[key].isShow = false;
                    }
                });
                $('.copied-url-msg').addClass('hide');
                $('#shareWorkSpaceModal').modal('show');
            }

        }).error(function (data, status) {
            if (status == "204") {
                //$(".no-dataset-msg").show();
                //$(".toggle-all-row-element").fadeOut();
                //$(".no-dataset-msg").show();
                //$(".no-dataset-msg").addClass("animate");
                //$(".no-dataset-msg").addClass("animate");
                //$scope.searchResultMsgforSavedWorkSpace = "No data found.";
                //$scope.searchResultMsgforSharedWorkSpace = "No data found.";
                //$('#tblsavedworkSpace').hide();
                //$('#tblsharedworkSpace').hide();
                //setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
                $('.copied-url-msg').addClass('hide');
                $('#shareWorkSpaceModal').modal('show');
            }
            progressBarService.hideProgressBar();
        });
    };


}]);

// This Service Call SaveGraph Method.
app.service('SaveGraphServices', ['$http', '$location', '$cookies', 'plotDataService', '$rootScope', 'GetSpectrumIDServices', 'progressBarService', '$timeout', function ($http, $location, $cookies, plotDataService, $rootScope, GetSpectrumIDServices, progressBarService, $timeout) {
    this.SaveWorkSpace = function ($scope, workspaceid, isCreateNewWorkspace) {

        progressBarService.showProgressBar();
        var SavedWorkAreaCriteria = new Object();
        SavedWorkAreaCriteria.DataSetIds = $scope.spectrumIdList.toString();
        SavedWorkAreaCriteria.AreaName = $("#txtWorkspaceName").val();
        //SavedWorkAreaCriteria.UserId = $scope.UserId;
        SavedWorkAreaCriteria.SearchString = $scope.searchstringlist.toString();
        SavedWorkAreaCriteria.DeletedSearchString = $scope.deletedSearchString.toString();
        SavedWorkAreaCriteria.WorkAreaId = workspaceid;
        //SavedWorkAreaCriteria.WorkspaceId = objectWorkspaceId;
        SavedWorkAreaCriteria.FileNames = $scope.fileNameList.toString();
        SavedWorkAreaCriteria.isCreateNewWorkspace = isCreateNewWorkspace;
        SavedWorkAreaCriteria.DeletedObjectIds = $scope.deletedObjectIDs.toString();

        return $http({
            method: "POST",
            url: $scope.serviceBase + "SaveGraph",
            dataType: 'json',
            data: SavedWorkAreaCriteria,
            headers: { 'Content-Type': 'application/json' }
        }).success(function (data, status, headers) {
            if (status == "204") {
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
            }
            else {
                if (data.status == "1") {
                    //clear workspace details 
                    plotDataService.clearSpectrumIds();
                    plotDataService.clearTechnique();
                    plotDataService.clearDataSetDisplayString();
                    plotDataService.clearSearchString();
                    plotDataService.clearFiles();
                    $rootScope.SelectedWorkArea = null;
                    //if ($scope.SessionUploadID != '') {
                    //    GetSpectrumIDServices.deleteUnpublishedDataSets($scope, '', '', true);
                    //}
                    angular.element("#divCopyShare").show();
                    var workspaceurl = "http://" + location.host + location.pathname + "#/plotgraph?workspacedid=" + data.encrptedWorkAreaID;
                    $("#lblWorkSpaceUrl").html(workspaceurl);
                    $scope.saveWorkspaceEncryptedAreaID = data.encrptedWorkAreaID;
                    $scope.WorkSpaceUrl = workspaceurl;
                    $scope.savedWorkSpaceId = data.workAreaID;
                    //$scope.savedObjectWorkSpaceId = data.WorkSpaceID;
                    $scope.savedWorkSpaceEncId = data.encrptedWorkAreaID;
                    angular.element("#divViewDataSets").hide();
                    angular.element("#saveGraphBtn").addClass("hide");
                    angular.element("#saveGraphBtn").attr("disabled", true);
                    angular.element("#btnSaveAs").addClass("hide");
                    angular.element("#btnSaveAs").attr("disabled", true);
                    angular.element("#txtWorkspaceName").attr("disabled", true);

                    $("#txtWorkspaceName").removeClass("border-red");
                    $("#txtWorkspaceName").siblings("label").find("span").hide();
                }
                else if (data.status == "2") {
                    $("#txtWorkspaceName").addClass("border-red");
                    $("#txtWorkspaceName").focus();
                    $("#txtWorkspaceName").siblings("label").find("span").fadeIn();
                    $("#spanTitleError").html("Workspace with same title already exists.");
                }
            }
            progressBarService.hideProgressBar();
        }).error(function (data, status) {
            if (status == "204") {
                $(".no-dataset-msg").show();
                $(".no-dataset-msg").addClass("animate");
                setTimeout(function () { $(".no-dataset-msg").removeClass("animate") }, 2000);
            }
            progressBarService.hideProgressBar();
        });
    };

    this.ShareWorkSpace = function ($scope, sharememberList, url, workspaceType) {

        //var ShareWorkSpaceCriteria = new Object();
        //ShareWorkSpaceCriteria.inviteeName = inviteeName,
        //ShareWorkSpaceCriteria.To = to,
        //ShareWorkSpaceCriteria.Url = $scope.savedWorkSpaceEncId;
        //ShareWorkSpaceCriteria.WorkAreaId = workspaceid;
        //ShareWorkSpaceCriteria.SharingPersonName = getLocalValue('fullName');
        ////ShareWorkSpaceCriteria.UserID = $scope.UserId;
        //ShareWorkSpaceCriteria.WorkSpaceName = angular.element("#txtWorkspaceName").val();
        return $http({
            method: "POST",
            url: $scope.serviceBase + "shareworkspace",
            dataType: 'json',
            data: sharememberList,
            headers: { 'Content-Type': 'application/json' }
        }).success(function (data, headers, status) {

            if (data.savedWorkAreaList.length > 0) {
                $timeout(function () {
                    alert("Email sent successfully.");
                }, 50);
                var sharedDataDetails = data.savedWorkAreaList;
                angular.forEach(sharedDataDetails, function (datavalue, datakey) {
                    angular.forEach(sharememberList, function (value, key) {
                        if (datavalue.eSpectraSharedUserEmailID == value.To) {
                            if (datavalue.workspaceSharedUserID == 0) {
                                $scope.sharedWorkSpaceUsers.push({
                                    eSpectraSharedUserEmailID: value.To,
                                    eSpectraShareID: datavalue.eSpectraShareID,
                                    workspaceSharedUserID: 0,
                                    isShow: false,
                                    isShowArrow: false,
                                    isShowRightArrow: false,
                                    isShowDownArrow: false
                                });
                            } else {
                                $scope.sharedWorkSpaceUsers.push({
                                    eSpectraSharedUserEmailID: value.To,
                                    eSpectraShareFullName: datavalue.eSpectraShareFullName,
                                    eSpectraShareID: datavalue.eSpectraShareID,
                                    workspaceSharedUserID: datavalue.workspaceSharedUserID,
                                    isShow: false,
                                    isShowArrow: false,
                                    isShowRightArrow: false,
                                    isShowDownArrow: false
                                });
                            }
                        }
                    });
                });

                $scope.sharedWorkSpaceUsers[0].isShow = true;
                if ($scope.sharedWorkSpaceUsers.length > 1) {
                    $scope.sharedWorkSpaceUsers[0].isShowArrow = true;
                    $scope.sharedWorkSpaceUsers[0].isShowRightArrow = true;
                    $scope.sharedWorkSpaceUsers[0].isShowDownArrow = false;
                }
                if (workspaceType == 'savedWorkspace') {
                    $scope.savedWorkspaceSearchResult[$scope.currentSavedWorkspaceIndex].workspaceCount = $scope.sharedWorkSpaceUsers.length;
                }
            }
            if (data.message.length > 0) {
                if (data.status == 3) {
                    $scope.message = data.message;
                } else {
                    $scope.message = "Workspace is already shared to " + data.message + ". "
                }
                $scope.isError = true;
            }
            progressBarService.hideProgressBar();
        }).error(function (data, status) {
            progressBarService.hideProgressBar();
            if (status == "204") {
            }
        });
    };
}]);

app.directive('onFinishRender', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$emit(attr.broadcasteventname ? attr.broadcasteventname : 'ngRepeatFinished');
                });
            }
        }
    }
});

app.directive('preventRightClick', [

            function () {
                return {
                    restrict: 'A',
                    link: function ($scope, $ele) {
                        $ele.bind("contextmenu", function (e) {
                            e.preventDefault();
                        });
                    }
                };
            }
]);